export function inhaltsverzeichnisPlugin(md) {
  function parseEntries(lines) {
    const entries = [];

    // Erlaubt z. B.:
    // [- Titel](#titel)
    // [-- Untertitel](#untertitel)
    // [--- Punkt](#punkt)
    // Auch mit Leerzeichen zwischen den Bindestrichen:
    // [- - Untertitel](#untertitel)
    // [- - - Punkt](#punkt)
    const regex = /^\[\s*((?:-\s*)+)\s+(.*?)\s*\]\((.*?)\)\s*$/;

    // z. B. [1,2,3] => "1.2.3"
    const counters = [];

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) continue;

      const match = trimmed.match(regex);
      if (!match) continue;

      const dashGroup = match[1];
      const text = match[2].trim();
      const link = match[3].trim();

      // Anzahl der tatsächlichen Bindestriche = Level
      const level = (dashGroup.match(/-/g) || []).length;

      // Falls direkt mit einem tieferen Level begonnen wird,
      // fehlende Elternstufen mit 1 initialisieren
      while (counters.length < level - 1) {
        counters.push(1);
      }

      // Auf aktuelle Ebene kürzen
      counters.length = level;

      // Aktuellen Level-Zähler erhöhen oder initialisieren
      counters[level - 1] = (counters[level - 1] || 0) + 1;

      const number = counters.join(".");

      entries.push({
        text,
        link,
        level,
        number,
      });
    }

    return entries;
  }

  function container(state, startLine, endLine, silent) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    const firstLine = state.src.slice(start, max).trim();

    if (
      firstLine !== ":::inhaltsverzeichnis" &&
      firstLine !== "::: inhaltsverzeichnis" &&
      firstLine !== ":::table-of-contents" &&
      firstLine !== "::: table-of-contents"
    ) {
      return false;
    }

    if (silent) return true;

    let nextLine = startLine + 1;
    let found = false;
    const lines = [];

    while (nextLine < endLine) {
      const lineStart = state.bMarks[nextLine] + state.tShift[nextLine];
      const lineEnd = state.eMarks[nextLine];
      const line = state.src.slice(lineStart, lineEnd);

      if (line.trim() === ":::") {
        found = true;
        break;
      }

      lines.push(line);
      nextLine++;
    }

    if (!found) return false;

    const entries = parseEntries(lines);

    const token = state.push("inhaltsverzeichnis", "", 0);
    token.block = true;
    token.map = [startLine, nextLine + 1];
    token.meta = { entries };
    token.attrSet("entries", JSON.stringify(entries));

    state.line = nextLine + 1;
    return true;
  }

  md.block.ruler.before("fence", "inhaltsverzeichnis", container);
}